import { render, staticRenderFns } from "./OffCanvasDetailsToimeksianto.vue?vue&type=template&id=2b80322e&scoped=true&"
import script from "./OffCanvasDetailsToimeksianto.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsToimeksianto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80322e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b80322e')) {
      api.createRecord('2b80322e', component.options)
    } else {
      api.reload('2b80322e', component.options)
    }
    module.hot.accept("./OffCanvasDetailsToimeksianto.vue?vue&type=template&id=2b80322e&scoped=true&", function () {
      api.rerender('2b80322e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsToimeksianto.vue"
export default component.exports